/* KINETICS — shared init: scroll-reveal for .kx-rv elements.
   Load once in layout/theme.liquid before </body>:
   <script src="{{ 'kinetics.js' | asset_url }}" defer></script> */
(function () {
  function reveal() {
    var els = document.querySelectorAll('.kx-rv:not(.kx-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kx-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('kx-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
